export default __webpack_public_path__ + "static/4-b14dd8b1d314903008112b87f355a50a.png";